import { SVGProps } from 'react';

export const IconDrag = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} viewBox='0 0 20 20' fill='none'>
      <rect x='6.40002' y='3.99999' width='2.4' height='2.4' rx='1.2' fill='currentColor' />
      <rect x='6.40002' y='8.8' width='2.4' height='2.4' rx='1.2' fill='currentColor' />
      <rect x='6.40002' y='13.6' width='2.4' height='2.4' rx='1.2' fill='currentColor' />
      <rect x='11.2' y='3.99999' width='2.4' height='2.4' rx='1.2' fill='currentColor' />
      <rect x='11.2' y='8.8' width='2.4' height='2.4' rx='1.2' fill='currentColor' />
      <rect x='11.2' y='13.6' width='2.4' height='2.4' rx='1.2' fill='currentColor' />
    </svg>
  );
};
